module.exports = __webpack_public_path__ + "img/rs.91d90200.svg";